import produce from 'immer';

const INITIAL_STATE = {
  list: [],
  registry: {},
  loading: false,
  saving: false,
  error: false
};

export default function projectTeam(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@projectTeams/INDEX_REQUEST':
    case '@projectTeams/DELETE_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
        draft.error = false;
      });

    case '@projectTeams/CREATE_REQUEST':
    case '@projectTeams/UPDATE_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
        draft.error = false;
      });

    case '@projectTeams/READ_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
        draft.error = false;
        draft.registry = {};
      });

    case '@projectTeams/CREATE_SUCCESS':
    case '@projectTeams/UPDATE_SUCCESS':
    case '@projectTeams/DELETE_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.saving = false;
      });

    case '@projectTeams/INDEX_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.list = action.payload.data;
      });

    case '@projectTeams/READ_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.error = false;
        draft.registry = action.payload.data;
      });

    case '@projectTeams/INDEX_FAILURE':
    case '@projectTeams/CREATE_FAILURE':
    case '@projectTeams/UPDATE_FAILURE':
    case '@projectTeams/DELETE_FAILURE':
      return produce(state, draft => {
        draft.loading = false;
        draft.error = true;
        draft.saving = false;
      });

    case '@projectTeams/READ_FAILURE':
      return produce(state, draft => {
        draft.loading = false;
        draft.error = true;
        draft.registry = {};
      });

    default:
      return state;
  }
}
